import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import {Button, Col, Container, Row} from "reactstrap";
import {NotificationManager} from "react-notifications";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";

const Launch = (props) => {
    const history = useHistory();
    const [launchDate, setLaunchDate] = useState(null);
    const [closingDate, setClosingDate] = useState(null);
    const [assessmentInfo, setAssesssmentInfo] = useState({assessmentName: "error", assessmentFor: "error"});
    const today = new Date();
    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.userData.eventData?.assessmentName && props.userData.eventData?.assessmentFor) {
            setAssesssmentInfo({
                assessmentName: props.userData.eventData?.assessmentName,
                assessmentFor: props.userData.eventData?.assessmentFor
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Event Lost',
                text: 'Kindly Create Event Again',
                confirmButtonText: 'Proceed',
                allowOutsideClick: false
            }).then(result => {
                if (result.isConfirmed) {

                    history.push("/assessment/info");
                }
            })
        }
        if (props.userData?.eventData?.launchDate) {

            const _date = new Date(props?.userData?.eventData?.launchDate);
            setLaunchDate(_date);
        }
        if (props.userData?.eventData?.closingDate) {
            const _date = new Date(props.userData?.eventData?.closingDate);
            setClosingDate(_date)
        }
    }, []);

    const handleLaunchDateChange = (date) => {
        setLaunchDate(date);
    };
    const handleClosingDateChange = (date) => {
        setClosingDate(date);
    };
    const handleSubmit = () => {
        console.log(launchDate, "Launch date");
        console.log(closingDate, "closing date");
        console.log(props, 'props in launch');
        
        if (launchDate > closingDate) {
            NotificationManager.error("Invalid Dates");
            return;
        }
        if (launchDate && closingDate) {
            props.setUserData({
                ...props.userData,
                eventData: {
                    ...props.userData.eventData,
                    // launchDate: moment(launchDate).format('YYYY-MM-DD'),
                    // closingDate: moment(closingDate).format('YYYY-MM-DD'),
                    startTime: launchDate,
                    endTime: closingDate,
                    ...(props.userData?.eventData?.candidateFlow && {
                        cf_startTime: launchDate,
                        cf_endTime: closingDate,
                    }),
                    // launchDate: launchDate,
                    // closingDate: closingDate,
                }
            })
            history.push("/assessment/selection");
        } else {
            NotificationManager.error("Please Select Dates");
        }
    }

    const previous = () => {
        history.goBack();
    }
    return (
        <Container className="ml-0 right-content-container">
            <Row className="">
                <Col>
                    <h1 className="">Your <span
                        className="active-text-color text-capitalize">{assessmentInfo.assessmentName} </span>
                        For <span className="warning-text-color text-capitalize">{assessmentInfo.assessmentFor}</span>
                    </h1>
                    <hr className="mb-0 mt-1 heading-hr mx-2"/>
                </Col>
            </Row>
            <div>
                <h2 className="active-text-color">Launch Date & Availability</h2>
                <div className="">
                    <div>
                        <span className='fs-14'>
                            Please select launching and closing dates:
                        </span>
                        <div className="inner-assessment-content">
                            <div style={{padding: "20px 0"}}>
                                <Row className='mx-auto'>
                                    <Col className='mx-auto' sm={12} lg={10} xl={6}>
                                        <div className="date-wrapper">
                                            <label>
                                                <DatePicker
                                                    showIcon
                                                    className='assessment-input w-100 pl-5'
                                                    selected={launchDate}
                                                    onChange={handleLaunchDateChange}
                                                    showTimeSelect
                                                    selectsStart
                                                    startDate={launchDate}
                                                    endDate={closingDate}
                                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                                    placeholderText="Select start time"
                                                    minDate={today}
                                                />
                                            </label>
                                            <div>
                                                {/*<label className="fs-14 ml-2 font-weight-600">Launch Date</label>*/}
                                                <label className="fs-14 ml-2 font-weight-600">Start Time</label>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col className='mx-auto' sm={12} lg={10} xl={6}>
                                        <div className="date-wrapper">
                                            <label>
                                                <DatePicker
                                                    showIcon
                                                    className='assessment-input pl-5 w-100'
                                                    selected={closingDate}
                                                    onChange={handleClosingDateChange}
                                                    showTimeSelect
                                                    selectsEnd
                                                    startDate={launchDate}
                                                    endDate={closingDate}
                                                    disabled={!launchDate}
                                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                                    placeholderText="Select end time"
                                                    minDate={launchDate || Date.now()}
                                                />
                                            </label>
                                            <div>
                                                {/*<label className="fs-14 ml-2 font-weight-600">Closing Date</label>*/}
                                                <label className="fs-14 ml-2 font-weight-600">End Time</label>
                                            </div>
                                        </div>
                                        {/*<p className='art-head'>*/}
                                        {/*    Selected Slots*/}
                                        {/*</p>*/}
                                        {/*<div className="datepicker-container">*/}
                                        {/*    <Button className='calendar-icon '>*/}
                                        {/*        Delete*/}
                                        {/*    </Button>*/}
                                        {/*    <DatePicker*/}
                                        {/*        className='date-pick px-3 my-2'*/}
                                        {/*        // selected={launchDate}*/}
                                        {/*        dateFormat="yyyy-MM-dd"*/}
                                        {/*        placeholderText="Slot 1"*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        {/*<div className="datepicker-container">*/}
                                        {/*    <Row>*/}
                                        {/*        <Button className='calendar-icon clander-icon1 '>*/}
                                        {/*            Done*/}
                                        {/*        </Button>*/}
                                        {/*        <Button className='calendar-icon clander-icon2 '>*/}
                                        {/*            Delete*/}
                                        {/*        </Button>*/}
                                        {/*    </Row>*/}
                                        {/*    <DatePicker*/}
                                        {/*        className='date-pick px-3 my-2 '*/}
                                        {/*        // selected={launchDate}*/}
                                        {/*        dateFormat="yyyy-MM-dd"*/}
                                        {/*        placeholderText="Slot 2"*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        {/*<div className="datepicker-container">*/}
                                        {/*    <Button className='calendar-icon '>*/}
                                        {/*        Delete*/}
                                        {/*    </Button>*/}
                                        {/*    <DatePicker*/}
                                        {/*        className='date-pick px-3 my-2 '*/}
                                        {/*        // selected={launchDate}*/}
                                        {/*        dateFormat="yyyy-MM-dd"*/}
                                        {/*        placeholderText="Slot 3"*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                    <Row className="buttons-div">
                        <Col sm={12} xs={12} md={6} lg={8}></Col>
                        <Col sm={12} xs={12} md={3} lg={2}>
                            <Button className="previous-button text-white w-100" onClick={previous}
                                    color="">Previous</Button>
                        </Col>
                        <Col sm={12} xs={12} md={3} lg={2}>
                            <Button className="nextButton px-sm-0 border-0 text-white px-5 w-100"
                                    onClick={handleSubmit}
                                    color="">Next</Button>
                        </Col>
                    </Row>
                    {/*<div className="buttons-div">*/}
                    {/*    <div className="d-flex align-items-center" role="button">*/}
                    {/*        <img src={demoButton} alt="" height={17}/>*/}
                    {/*        <span className="text-dark font-weight-600 mx-2">Previous</span>*/}
                    {/*    </div>*/}
                    {/*    <div className="btn-vr"/>*/}
                    {/*    <div className="d-flex align-items-center" role="button" onClick={submitForm}>*/}
                    {/*        <span className="font-weight-600 mx-2 active-text-color">Next</span>*/}
                    {/*        <img src={nextBUtton} alt="" height={17}/>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </div>
        </Container>
    );
};

export default Launch;
